import { observer } from 'mobx-react-lite'
import React, { useState, useContext } from 'react'
import { ThreeDotsVertical, Trash } from 'react-bootstrap-icons'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../../../../../FormComponents/Toasts'
import OutsideClickClose from '../../../../../../../OutsideClickClose'
import { useReadOnly } from '../../../../../../../../contexts/ReadOnlyContext'

export default observer(function ActionGroupDropdownButton({ actionGroup, campaignScenario }) {
  const readOnly = useReadOnly()
  const { id } = useParams()
  const { primaryScenarioId } = useContext(CampaignContext)
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const deleteActionGroup = () => {
    axiosService.delete(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/campaign_scenario_action_groups/${actionGroup.id}`)
    .then(deletedActionGroup => {
      campaignScenario.campaign_scenario_action_groups = campaignScenario.campaign_scenario_action_groups.filter(actionGroup => actionGroup.id !== deletedActionGroup.id)
      campaignScenario.actions = campaignScenario.actions.filter(action => action.campaign_scenario_action_group_id !== deletedActionGroup.id)

      toastSuccess('Action Group deleted')
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  if (readOnly) return null

  return (
    <div className="relative">
      <button className="mx-2 p-2 rounded-md" onClick={toggleDropdown}><ThreeDotsVertical /></button>
      <OutsideClickClose
        isOpen={dropdownOpen}
        onClose={() => setDropdownOpen(false)}
      >
        {dropdownOpen &&
          <div className="absolute bg-green h-full rounded-md flex" style={{ left: 12, bottom: -35 }}>
          <button className="bg-gray-400 text-white z-10 py-2 px-3 hover:bg-rb-green rounded-md" onClick={deleteActionGroup}><Trash /></button>
        </div>
        }
      </OutsideClickClose>
    </div>
  )
})